import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TPriceListDM from './TPriceListDM'

export default class TPriceListSuperiorDM extends Data {
	public static className = 'TPriceListSuperiorDM'
	public static primaryKey = 'SequenceNumber'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.SequenceNumber!
	}

	RecordMod?: number
	RecordES?: number
	RecordNo?: number
	RecordID?: number
	RecordState?: number
	Level?: number
	SequenceNumber?: number
	HeaderRID?: number
	IsPriceSource?: string
	IsArticleSource?: string
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	@Type(() => TPriceListDM)
	PriceListRID?: TPriceListDM
}